import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDart = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 16.9699C13.21 16.9699 15 15.1699 15 12.9599C15 10.7499 13.21 8.94995 11 8.94995C8.79 8.94995 7 10.7499 7 12.9599C7 15.1699 8.79 16.9699 11 16.9699Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4802 10.0901C19.1402 11.8101 19.1902 13.7001 18.6202 15.4501C18.0602 17.2001 16.9102 18.7001 15.3702 19.7001C13.8302 20.7001 12.0002 21.1501 10.1802 20.9501C8.3602 20.7601 6.6602 19.9501 5.3602 18.6501C4.0702 17.3501 3.2502 15.6401 3.0502 13.8201C2.8602 11.9901 3.29019 10.1501 4.29019 8.61009C5.28019 7.07009 6.78023 5.9101 8.52023 5.3401C10.2602 4.7701 12.1502 4.81011 13.8602 5.47011",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9702 5.97998L11.0103 12.97",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 6H18V3",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgDart;
